import * as React from 'react';
import get from 'lodash/get';
import { inject } from 'mobx-react';
import { replacePlaceholders } from '../utils/replacePlaceholders';

// TODO: Is it possible to inject translations as with the React component?
// export const translate = inject('translations')(({ translations }) => text => get(translations, text, text));

export const translate = (translations, text, placeholders?) => {
    const translation = get(translations, text, text);
    return placeholders
        ? replacePlaceholders({
              values: placeholders,
              text: translation,
          })
        : translation;
};

// Component to get translated text from translation dictionary
// Children should be a string, but any other child types, e.g. a component, will simply pass through

const Translate: React.SFC<any> = ({
    translations,
    placeholders,
    children = null,
}) => {
    return translate(translations, children, placeholders);
};

export default inject('translations')(Translate);



// WEBPACK FOOTER //
// ./src/Components/Translate.tsx